/* eslint-disable */
import PropTypes from 'prop-types';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const BannerNotificationPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The JSS classes to use for banner
   */
  bannerClasses: ThemeStatePropTypes.classes,

  /**
   * Is visible
   */
  hidden: PropTypes.bool,

  /**
   * Buttons
   */
  buttons: PropTypes.object,

  /**
   * Content
   */
  content: PropTypes.object,

  /**
   * Icon
   */
  icon: PropTypes.object,
};

export default BannerNotificationPropTypes;
